import * as React from "react" ;
import Box from "@mui/material/Box";
import {ThemeProvider} from "@mui/material/styles";
// @ts-ignore
import {Theme} from "../../Components/styles/styles.js";
import dayjs from "dayjs";
// @ts-ignore
import {DEF} from "../../const.ts";
import css from "./LeadRow.module.css";
import clsx from "clsx";

interface LeadRowProps {
    searchId: string;
    createdDate: string | Date;
    updatedDate: string | Date;
    epid: string | null;
    availableEpids: string[] | null;
    leadStatus: string;
}

export const LeadRow = (args: LeadRowProps) => {

    const successError = (epid: string|null) => {
        if (epid && epid.length) {
            return css.success;
        } else {
            return css.error;
        }
    }

    return (
        <Box className={clsx(css.leadRow, successError(args.epid))} >
            <ThemeProvider theme={Theme}>

                <Box className={clsx(css.leadRowItemEpid)}>
                    <Box className='title'>Epid</Box>
                    <Box className='value'>{args.epid || 'Nie przejęty'}</Box>
                    <Box className={clsx(css.leadRowItemEpidAvailable)}>
                        ({args.availableEpids && 'W zasięgu: ' + args.availableEpids.join(", ")})
                    </Box>
                </Box>

                <Box className={clsx(css.leadRowItem)}>
                    <Box className='title'>Data utworzenia</Box>
                    <Box className='value'>{dayjs(args.createdDate).format(DEF.DATETIME_FORMAT)}</Box>
                </Box>

                <Box className={clsx(css.leadRowItem)}>
                    <Box className='title'>Data aktualizacji</Box>
                    <Box className='value'>{dayjs(args.updatedDate).format(DEF.DATETIME_FORMAT)}</Box>
                </Box>

                <Box className={clsx(css.leadRowItemStatus)}>
                    <Box className='title'>Status</Box>
                    <Box className='value'>{args.leadStatus}</Box>
                </Box>

            </ThemeProvider>
        </Box>
    )
}